module.exports = __webpack_public_path__ + "assets/prescription_service.f57ff6a5.png";